'use client';

import { useState } from 'react';

import ChevronIcon from '@/fo/icons/base/icons/chevron24.svg';
import { UiKitCollapseBase } from '@/fo/ui/kit/collapse/base';

import { styles } from './GroupLinks.styles';

export interface GroupLinksProps {
  title?: React.ReactNode;
  children?: React.ReactNode;
}

export function GroupLinks({ title, children }: GroupLinksProps) {
  const slots = styles();
  const [collapse, setCollapse] = useState(true);

  return (
    <>
      <div
        className={slots.header()}
        onClick={() => setCollapse((s) => !s)}
      >
        {title}
        <ChevronIcon className={slots.chevron()} />
      </div>
      <UiKitCollapseBase
        collapse={collapse}
        className={slots.content()}
      >
        {children}
      </UiKitCollapseBase>
    </>
  );
}
